import React, { useMemo } from 'react';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import isEmpty from 'lodash-es/isEmpty';
import PropTypes from 'prop-types';
import { v1 } from 'uuid';
import InputGroup from '@panneau/field-input-group';

var definition = [{
  id: 'text',
  component: 'text'
}, {
  id: 'email',
  component: 'email'
}, {
  id: 'password',
  component: 'password'
}, {
  id: 'telephone',
  component: 'telephone'
}, {
  id: 'textarea',
  component: 'textarea'
}];

var styles = {"inputElement":"panneau-field-text-inputElement"};

var _excluded = ["horizontal"];
var propTypes$5 = {
  feedback: PropTypes.oneOf(['valid', 'invalid', 'loading']),
  value: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  nativeOnChange: PropTypes.bool,
  type: PropTypes.oneOf(['text', 'email', 'tel', 'password', 'textarea', 'number']),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  size: PropTypes.oneOf([null, 'lg', 'sm']),
  maxLength: PropTypes.number,
  prepend: PropTypes.node,
  append: PropTypes.node,
  min: PropTypes.number,
  max: PropTypes.number,
  dataList: PropTypes.arrayOf(PropTypes.string),
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any // eslint-disable-line
  })]),
  style: PropTypes.shape({}),
  className: PropTypes.string
};
var defaultProps$5 = {
  feedback: null,
  value: null,
  errors: null,
  required: false,
  disabled: false,
  readOnly: false,
  nativeOnChange: false,
  type: null,
  placeholder: null,
  onChange: null,
  onFocus: null,
  onBlur: null,
  align: null,
  size: null,
  maxLength: null,
  prepend: null,
  append: null,
  min: null,
  max: null,
  dataList: null,
  inputRef: null,
  style: null,
  className: null
};
var InputField = function InputField(_ref) {
  var feedback = _ref.feedback,
    value = _ref.value,
    errors = _ref.errors,
    required = _ref.required,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    nativeOnChange = _ref.nativeOnChange,
    type = _ref.type,
    placeholder = _ref.placeholder,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    align = _ref.align,
    size = _ref.size,
    maxLength = _ref.maxLength,
    prepend = _ref.prepend,
    append = _ref.append,
    min = _ref.min,
    max = _ref.max,
    dataList = _ref.dataList,
    inputRef = _ref.inputRef,
    style = _ref.style,
    className = _ref.className;
  var dataListId = useMemo(function () {
    return dataList !== null ? v1() : null;
  }, [dataList]);
  var elProps = {
    ref: inputRef,
    className: classNames([styles.inputElement, 'form-control', _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "form-control-".concat(size), size !== null), 'is-valid', feedback === 'valid'), 'is-invalid', feedback === 'invalid' || errors !== null), className, className !== null)]),
    onFocus: onFocus,
    onBlur: onBlur,
    value: value !== null ? value : '',
    style: {
      textAlign: align
    },
    placeholder: placeholder,
    type: type,
    maxLength: maxLength,
    min: min,
    max: max,
    required: required,
    disabled: disabled,
    readOnly: readOnly,
    list: dataListId,
    onChange: nativeOnChange ? onChange : function (_ref3) {
      var _ref3$target$value = _ref3.target.value,
        newValue = _ref3$target$value === void 0 ? '' : _ref3$target$value;
      return onChange !== null ? onChange(!isEmpty(newValue) ? newValue : null) : null;
    }
  };
  elProps.horizontal;
    var cleanProps = _objectWithoutProperties(elProps, _excluded);
  var inputElement = type !== 'textarea' ? /*#__PURE__*/React.createElement("input", Object.assign({}, cleanProps, {
    style: style
  })) : /*#__PURE__*/React.createElement("textarea", Object.assign({
    style: style
  }, cleanProps));
  var withInputGroup = prepend !== null || append !== null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, withInputGroup ? /*#__PURE__*/React.createElement(InputGroup, {
    prepend: prepend,
    append: append
  }, inputElement) : inputElement, dataListId !== null ? /*#__PURE__*/React.createElement("datalist", {
    id: dataListId
  }, dataList.map(function (data, dataIndex) {
    return /*#__PURE__*/React.createElement("option", {
      key: "option-".concat(dataIndex)
    }, data);
  })) : null);
};
InputField.propTypes = propTypes$5;
InputField.defaultProps = defaultProps$5;
 // React.forwardRef((props, ref) => <InputField inputRef={ref} {...props} />);

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$4 = {};
var defaultProps$4 = {};
var EmailField = function EmailField(props) {
  return /*#__PURE__*/React.createElement(InputField, Object.assign({}, props, {
    type: "email"
  }));
};
EmailField.propTypes = propTypes$4;
EmailField.defaultProps = defaultProps$4;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$3 = {};
var defaultProps$3 = {};
var PasswordField = function PasswordField(props) {
  return /*#__PURE__*/React.createElement(InputField, Object.assign({}, props, {
    type: "password"
  }));
};
PasswordField.propTypes = propTypes$3;
PasswordField.defaultProps = defaultProps$3;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$2 = {};
var defaultProps$2 = {};
var TelephoneField = function TelephoneField(props) {
  return /*#__PURE__*/React.createElement(InputField, Object.assign({}, props, {
    type: "tel"
  }));
};
TelephoneField.propTypes = propTypes$2;
TelephoneField.defaultProps = defaultProps$2;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes$1 = {};
var defaultProps$1 = {};
var TextareaField = function TextareaField(props) {
  return /*#__PURE__*/React.createElement(InputField, Object.assign({}, props, {
    type: "textarea"
  }));
};
TextareaField.propTypes = propTypes$1;
TextareaField.defaultProps = defaultProps$1;

/* eslint-disable react/jsx-props-no-spreading */
var propTypes = {};
var defaultProps = {};
var TextField = function TextField(props) {
  return /*#__PURE__*/React.createElement(InputField, Object.assign({}, props, {
    type: "text"
  }));
};
TextField.propTypes = propTypes;
TextField.defaultProps = defaultProps;

export { EmailField as Email, PasswordField as Password, TelephoneField as Telephone, TextareaField as Textarea, TextField as default, definition };
